module.exports = __webpack_public_path__ + "img/JP-COVER.d4564ea3.png";